<div #modalView class="modal-dialog popover" role="document">
  <div class="modal-content" *ngIf="calEvent">
    <div class="header-dialog" [ngClass]="{'overlay': titleOverlay}">
      <i class="fa fa-pencil" *ngIf="calEvent.isCreator || (calendarEvent && !!calendarEvent.myAttendee)" (click)="editEvent()" title="Chỉnh sửa"></i>
      <i class="fa fa-trash" *ngIf="calEvent.isCreator" (click)="removeEvent()" title="Xóa"></i>
      <i (click)="hide()" class="fa fa-times" title="Đóng"></i>
    </div>
    <div class="content-dialog" [ngStyle]="{'max-height.px': maxHeight}">
      <div class="field-group">
        <i class="field-icon fa fa-calendar"></i>
        <div class="field-content">
          <div style="font-size:18px" [innerHTML]="calendarEvent?.subject"></div>
          <div>{{calendarEvent?.timeDisplay}}</div>
          <div>{{calendarEvent?.repeatText}}</div>
        </div>
      </div>
      <div class="field-group" *ngIf="calEvent && calEvent.memberStr">
        <i class="field-icon fa fa-users" title="Khách mời tham dự"></i>
        <div class="field-content">
          <calendar-attendee-list [attendees]="calEvent?.attendees" [expandable]="true"></calendar-attendee-list>
        </div>
      </div>
      <div class="field-group" *ngIf="calEvent && calEvent.location">
        <i class="field-icon fa fa-map-marker" title="Địa điểm"></i>
        <div class="field-content">{{ calEvent?.location }}</div>
      </div>
      <div class="field-group" *ngIf="calendarEvent && calendarEvent.summary">
        <i class="field-icon fa fa-align-left" title="Mô tả sự kiện"></i>
        <div class="field-content" [innerHTML]="calendarEvent?.summary"></div>
      </div>
      <div class="field-group" *ngIf="calEvent && calEvent?.fullname">
        <i class="field-icon fa fa-user-circle" title="Người tạo"></i>
        <div class="field-content">{{ calEvent?.fullname }}</div>
      </div>
      <div class="field-group" *ngIf="calEvent?.attachments?.length">
        <i class="field-icon fa fa-paperclip" title="Tập tin đính kèm"></i>
        <div class="field-content">
          <calendar-attachment-list [calEvent]="calEvent"></calendar-attachment-list>
        </div>
      </div>
    </div>
  </div>
</div>
<calendar-dialog-delete #dialogRemove hidden [calEvent]="calEvent" (onDelete)="changeEvent($event)"></calendar-dialog-delete>
